import { create } from "zustand";

/**
 * In-flight MedChron exports, keyed by `${caseId}-${format}`. Module-level rather than component
 * state so every mounted export control shares one truth: an export started from the customization
 * dialog keeps showing on the chronology header after that dialog closes. Deliberately not
 * persisted — an export in flight belongs to this session only.
 */
interface MedChronExportingState {
  exportingKeys: Set<string>;
  markExporting: (key: string) => void;
  clearExporting: (key: string) => void;
}

export const exportingKey = (caseId: string, format: string) => `${caseId}-${format}`;

export const useMedChronExportingStore = create<MedChronExportingState>()((set) => ({
  exportingKeys: new Set<string>(),
  markExporting: (key) =>
    set((state) => ({ exportingKeys: new Set(state.exportingKeys).add(key) })),
  clearExporting: (key) =>
    set((state) => {
      const next = new Set(state.exportingKeys);
      next.delete(key);
      return { exportingKeys: next };
    }),
}));
